import { GlobalWindowPropertyHelper } from './GlobalWindowPropertyHelper';
/**
 * Return a singleton-instance of the supplied class
 */
export function SingletonInstanceOf(singletonClassPointer) {
    return SingletonInstanceLike(singletonClassPointer, () => {
        return new singletonClassPointer();
    });
    /*    const inst = (cls as any).___instance_of;
    if (inst) {
        return inst;
    }
    return ((cls as any).___instance_of = new cls());*/
}
/**
 * Return a singleton-instance attached to the supplied class, instanciated using the supplied closure
 */
export function SingletonInstanceLike(singletonClassPointer, closure) {
    const keyBase = '___instance_';
    let cnt = 0;
    const anyClassPointer = singletonClassPointer;
    for (;;) {
        const key = keyBase + cnt;
        if (key in anyClassPointer && !anyClassPointer.hasOwnProperty(key)) {
            // Hvis den har en property med det navnet, men den er arvet, så prøver vi på nytt med annen key
            cnt++;
            continue;
        }
        if (key in anyClassPointer && anyClassPointer[key]) {
            return anyClassPointer[key];
        }
        return (anyClassPointer[key] = closure());
    }
}
export function GlobalSingletonInstanceOf(singletonClassName, singletonClassPointer) {
    return SingletonInstanceLike(singletonClassPointer, () => {
        const inst = GlobalWindowPropertyHelper.get(singletonClassName, new singletonClassPointer());
        if (inst) {
            return inst;
        }
        throw new Error('Sorry');
    });
}
